import React from 'react';
import { connect } from 'react-redux';
import { reset } from 'redux-form';
import classNames from 'classnames';

import { formValidate } from '@eventbrite/eds-utils';
import VenueMapThumbnailView from '../venueMapThumbnailView/VenueMapThumbnailView';
import { SQUARE } from '../venueMapThumbnailView/constants';
import { Button } from '@eventbrite/eds-button';

import { gettext } from '@eventbrite/i18n';
import { createPickASeatOrder } from '../../actions/order/common';
import {
    BUY_ON_MAP_FORM_NAME,
    TICKETS_SELECTION_PAGE_FORM_NAME,
} from '../../constants';
import {
    PICK_A_SEAT,
    triggerTrackingPixelAction,
} from '../../actions/pixelAnalytics';
import { getEventSeatMapThumbnailSrc } from '../../selectors/event';
import { areAdmissionTicketsAvailable } from '../../selectors/tickets/pureSelectors';
import { getIsTicketSelectionButtonDisabledByCaptcha } from '../../selectors/getIsTicketSelectionButtonDisabledByCaptcha';
import './BuyOnMapPaneContent.scss';

const BuyOnMapPaneContent = formValidate({
    form: BUY_ON_MAP_FORM_NAME,
})((props) => {
    const {
        handleSubmit,
        submitting,
        eventSeatMapThumbnailSrc,
        eventImageSrc,
        showPickASeat,
        disabled,
        thumbnailClassName,
    } = props;

    const onVenueMapThumbnailViewClick =
        showPickASeat && !disabled ? handleSubmit : null;

    const venueMapThumbnail = eventSeatMapThumbnailSrc ? (
        <VenueMapThumbnailView
            thumbnailUrl={eventSeatMapThumbnailSrc}
            fixedSize={SQUARE}
            onClick={onVenueMapThumbnailViewClick}
            __customContainerClassNames={thumbnailClassName}
        />
    ) : null;

    const buyOnMapSection = showPickASeat ? (
        <div
            className={classNames({
                'eds-l-pad-vert-6': eventSeatMapThumbnailSrc,
            })}
            data-testid="pick-a-seat-button"
        >
            <Button
                onClick={handleSubmit}
                isLoading={submitting}
                disabled={disabled}
            >
                {gettext('Buy on Map')}
            </Button>
        </div>
    ) : null;

    const isRenderingSomeContent = venueMapThumbnail || buyOnMapSection;

    return isRenderingSomeContent ? (
        <div
            className={classNames({
                'reserved-ticket-selection__buy-on-map-content': true,
                'checkout-widget__ticket-page-centered-content': true,
                'checkout-widget__ticket-page-centered-content__vertical':
                    !eventImageSrc &&
                    !eventSeatMapThumbnailSrc &&
                    showPickASeat,
            })}
        >
            {venueMapThumbnail}
            {buyOnMapSection}
        </div>
    ) : null;
});

export const mapStateToProps = (state) => ({
    eventImageSrc: state.event.properties.image,
    eventSeatMapThumbnailSrc: getEventSeatMapThumbnailSrc(state),
    showPickASeat: state.event.showPickASeat,
    disabled:
        !areAdmissionTicketsAvailable(state) ||
        getIsTicketSelectionButtonDisabledByCaptcha(state),
});

const mapDispatchToProps = (dispatch) => ({
    onSubmit: async () => {
        await dispatch(triggerTrackingPixelAction(PICK_A_SEAT));
        await dispatch(createPickASeatOrder());
        dispatch(reset(TICKETS_SELECTION_PAGE_FORM_NAME));
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(BuyOnMapPaneContent);
